var _excluded = ["image", "to", "href", "title", "openInNewTab", "onClick", "rel", "hasOpacity", "sizeSpace"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import space from "../../../utils/space";
import Link from "../../quarks/Link";
var StyledImageLinkAtm = styled(Link).withConfig({
  componentId: "sc-su9un9-0"
})(function (_ref) {
  var $hasOpacity = _ref.$hasOpacity,
    $sizeSpace = _ref.$sizeSpace;
  return css(["display:inline-flex;", " ", " ", ""], $hasOpacity && css(["opacity:0.7;&:hover{opacity:1;}"]), $sizeSpace && css(["width:", ";height:", ";"], space($sizeSpace), space($sizeSpace)), !$hasOpacity && css(["&:hover{filter:brightness(0.95);}"]));
});
function ImageLinkAtm(_ref2) {
  var image = _ref2.image,
    to = _ref2.to,
    href = _ref2.href,
    title = _ref2.title,
    openInNewTab = _ref2.openInNewTab,
    onClick = _ref2.onClick,
    rel = _ref2.rel,
    hasOpacity = _ref2.hasOpacity,
    sizeSpace = _ref2.sizeSpace,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledImageLinkAtm, _extends({
    to: to,
    href: href,
    title: title,
    openInNewTab: openInNewTab,
    onClick: onClick,
    rel: rel,
    $hasOpacity: !!hasOpacity,
    $sizeSpace: sizeSpace
  }, restProps), image);
}
export default ImageLinkAtm;